// import React, { useState } from "react";
import { observer } from "mobx-react";
import { useStore } from "../../../hooks/use-store";
import { Badge, Popover } from "antd";
// import Picker from "emoji-picker-react";
import style from "./recationControl.module.scss";
import KeynoteMenu from "../spaceMenu/KeynotesMenu";

import remixiconUrl from "remixicon/fonts/remixicon.symbol.svg";
import { ROLE } from "../../../types";
const ReactionControl = () => {
  const {
    dataStore: {
      // elementsStore,
      spaceStore,
      chatStore,
    },
  } = useStore();

  // const [visible, setVisible] = useState(false);
  return (
    <>
      {/* <Popover
        visible={visible}
        content={
          <Picker
            onEmojiClick={(event, data) => {
              console.log(data.emoji);
              elementsStore.addReaction(data.emoji);
              setVisible(false);
            }}
          />
        }
      >
        <button onClick={() => setVisible(!visible)} className={style.button}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="26px"
            height="26px"
          >
            <g id="surface168562888">
              <path
                style={{
                  stroke: "none",
                  fillRule: "nonzero",
                  fill: "rgb(100%,100%,100%)",
                  fillOpacity: 1,
                }}
                d="M 12 2 C 6.476562 2 2 6.476562 2 12 C 2 17.523438 6.476562 22 12 22 C 17.523438 22 22 17.523438 22 12 C 22 6.476562 17.523438 2 12 2 Z M 12 4 C 16.417969 4 20 7.582031 20 12 C 20 16.417969 16.417969 20 12 20 C 7.582031 20 4 16.417969 4 12 C 4 7.582031 7.582031 4 12 4 Z M 9 7 C 7.894531 7 7 7.894531 7 9 L 11 9 C 11 7.894531 10.105469 7 9 7 Z M 15 7 C 13.894531 7 13 7.894531 13 9 L 17 9 C 17 7.894531 16.105469 7 15 7 Z M 6 12 C 6 15.320312 8.679688 18 12 18 C 15.320312 18 18 15.320312 18 12 Z M 6 12 "
              />
            </g>
          </svg>

          <span>Reaction</span>
        </button>
      </Popover> */}

      <Badge
        count={chatStore.unreadCounter}
        // count={13}
        showZero={false}
        offset={[-12, 4]}
      >
        <button
          className={style.button}
          onClick={() => {
            chatStore.chatVisible ? chatStore.hide() : chatStore.show();
          }}
        >
          <svg
            width="24px"
            style={{ paddingBottom: "1px", paddingTop: "0" }}
            height="24px"
            className="remix"
            fill={chatStore.chatVisible ? "#07F800" : "white"}
          >
            <use xlinkHref={`${remixiconUrl}#ri-message-2-line`} />
          </svg>
          <span style={{ color: chatStore.chatVisible ? "#07F800" : "white" }}>
            {chatStore.chatVisible ? "Close" : "Chat"}
          </span>
        </button>
      </Badge>

      {/* {spaceStore.currentRoom?.plotId ? (
        <button
          className={style.button}
          onClick={() => {
            spaceStore.currentRoom?.focusModeEnabled
              ? spaceStore.updateRoom({
                  ...spaceStore.currentRoom!,
                  focusModeEnabled: false,
                })
              : spaceStore.updateRoom({
                  ...spaceStore.currentRoom!,
                  focusModeEnabled: true,
                });
          }}
        >
          <svg
            width="24px"
            style={{ marginBottom: 0 }}
            height="24px"
            className="remix"
            fill="white"
          >
            <use xlinkHref={`${remixiconUrl}#ri-map-pin-3-line`} />
          </svg>
          <span>
            {spaceStore.currentRoom?.focusModeEnabled ? "Cursor" : "Close"}
          </span>
        </button>
      ) : null} */}

      {spaceStore.role !== ROLE.GUEST ? (
        <>
          {/* <Popover
              placement="topLeft"
              popupVisible={true}
              style={{ width: "371px" }}
              content={<div>hello</div>}
            > */}
          <button
            className={style.button}
            onClick={() => {
              spaceStore.currentRoom?.focusModeEnabled
                ? spaceStore.updateRoom({
                    ...spaceStore.currentRoom!,
                    focusModeEnabled: false,
                    plotId: null,
                  })
                : spaceStore.updateRoom({
                    ...spaceStore.currentRoom!,
                    focusModeEnabled: true,
                    plotId: null,
                  });
            }}
          >
            <svg
              width="24px"
              style={{ marginBottom: 0 }}
              height="24px"
              className="remix"
              fill={
                spaceStore.currentRoom?.focusModeEnabled ? "white" : "#07F800"
              }
            >
              <use xlinkHref={`${remixiconUrl}#ri-artboard-line`} />
            </svg>
            <span
              style={{
                color: !spaceStore.currentRoom?.focusModeEnabled
                  ? "#07F800"
                  : undefined,
              }}
            >
              {spaceStore.currentRoom?.focusModeEnabled ? "Board" : "Close"}
            </span>
          </button>
          {/* </Popover> */}

          {spaceStore.currentRoom?.plotId ? (
            <button
              className={style.button}
              onClick={() => {
                spaceStore.updateRoom({
                  ...spaceStore.currentRoom!,
                  plotId: null,
                });
              }}
            >
              <svg
                width="24px"
                height="24px"
                className="remix"
                fill="#07F800"
                style={{ marginBottom: 0 }}
              >
                <use xlinkHref={`${remixiconUrl}#ri-slideshow-2-line`} />
              </svg>

              <span style={{ color: "#07F800" }}>Close</span>
            </button>
          ) : (
            <Popover
              placement="topLeft"
              popupVisible={true}
              style={{ width: "371px" }}
              content={<KeynoteMenu />}
            >
              <button>
                <svg
                  width="24px"
                  style={{ marginBottom: 0 }}
                  height="24px"
                  className="remix"
                  fill="white"
                >
                  <use xlinkHref={`${remixiconUrl}#ri-slideshow-2-line`} />
                </svg>
                <span>Slides</span>
              </button>
            </Popover>
          )}
        </>
      ) : null}

      {/* {spaceStore.recordingStarted ? <button onClick={() => {
        //@ts-ignore
        window.mediaRecorder.stop();
        // stop all tracks
        //@ts-ignore
        window.mediaStream.getTracks().forEach((track) => { track.stop(); });

        spaceStore.setRecordingStarted(false)
      }}>
        <svg
          width="24px"
          style={{ marginBottom: 0 }}
          height="24px"
          className="remix"
          fill={"red"}
        >
          <use xlinkHref={`${remixiconUrl}#ri-record-circle-line`} />
        </svg>
        Stop recording
      </button> : <button onClick={async () => {

        let recordedChunks: Blob[] = [];
        // const audioRecordConstraints = {
        //   echoCancellation: true
        // }


        const stream = await navigator.mediaDevices.getDisplayMedia({
          audio: {
            echoCancellation: true,
          },
          video: {
            height: { ideal: 2560 },
            width: { ideal: 1600 },
            frameRate: { ideal: 30 },

          },
          // @ts-ignore-next-line
          preferCurrentTab: true,

        });


        const mediaRecorder = new MediaRecorder(stream);
        // @ts-ignore
        window.mediaRecorder = mediaRecorder;
        // @ts-ignore
        window.mediaStream = stream;
        mediaRecorder.ondataavailable = function (e) {
          if (e.data.size > 0) {
            recordedChunks.push(e.data);
          }

          // if (shouldStop === true && stopped === false) {
          //     mediaRecorder.stop();
          //     stopped = true;
          // }
        };

        mediaRecorder.onstop = function () {
          // @ts-ignore
          const blob = new Blob(recordedChunks, {
            type: 'video/webm; codecs=vp9',//'video/webm;codecs=vp8,opus'
          });
          recordedChunks = []
          // const filename = window.prompt('Enter file name');

          // const recMediaFile = document.createElement("video");
          // recMediaFile.controls = true;
          const RecUrl = URL.createObjectURL(blob);

          //keep the recorded url as source
          // recMediaFile.src = RecUrl;
          // @ts-ignore
          // document.getElementById(`vid-recorder`).append(recMediaFile);

          const a = document.createElement('a')

          a.href = RecUrl
          a.download = `${Date.now()}`
          a.onclick = (e: MouseEvent) => e.stopPropagation()
          a.click()
        };

        mediaRecorder.start(200);
        spaceStore.setRecordingStarted(true)

        // // @ts-ignore
        // let chunksArr = [];

        // // permission to access camera and microphone
        // navigator.mediaDevices.getDisplayMedia({
        // audio: { echoCancellation: true },
        // video: {
        //   height: { ideal: 2560 },
        //   width: { ideal: 1600 },
        //   frameRate: { ideal: 30 },
        //   facingMode: "user"
        // },
        // // @ts-ignore-next-line
        // preferCurrentTab: true,
        // })
        //   .then((mediaStreamObj) => {

        //     // Create a new MediaRecorder instance
        //     const medRec = new MediaRecorder(mediaStreamObj, { mimeType: 'video/webm;codecs=vp8,opus' });
        //     // @ts-ignore
        //     window.mediaStream = mediaStreamObj;
        //     // @ts-ignore
        //     window.mediaRecorder = medRec;
        //     medRec.start();

        //     //when recorded data is available then push into chunkArr array
        //     medRec.ondataavailable = (e) => { chunksArr.push(e.data); };

        //     //stop the video recording
        //     medRec.onstop = () => {
        //       // @ts-ignore
        //       const blobFile = new Blob(chunksArr, { type: "video/webm" });
        //       chunksArr = [];

        //       // create video element and store the media which is recorded
        //       const recMediaFile = document.createElement("video");
        //       recMediaFile.controls = true;
        //       const RecUrl = URL.createObjectURL(blobFile);

        //       //keep the recorded url as source
        //       recMediaFile.src = RecUrl;
        //       // @ts-ignore
        //       document.getElementById(`vid-recorder`).append(recMediaFile);
        //     };
        //   })


        // OLD
        // const captureStream :MediaStream | null = null
        // const mediaRecorder: null | MediaRecorder = null
        // captureStream.value = await navigator.mediaDevices.getDisplayMedia({
        // audio: true,
        // video: true,
        // // @ts-ignore-next-line
        // preferCurrentTab: true,
        // })
        // const audioStream = await navigator.mediaDevices.getUserMedia({ audio: true })
        // // captureStream.value.getTracks().forEach((track) => {
        // //   // track.onended = onStop
        // // })
        // audioStream.getAudioTracks().forEach((track) => {
        //   captureStream.value?.addTrack(track)
        // })
        // mediaRecorder.value = new MediaRecorder(captureStream.value, {
        //   mimeType: 'video/webm; codecs=vp9',
        // })
        // mediaRecorder.value.start()
        // OLD

        // setup() {
        //   const chunks:Blob[] = []
        //   const captureStream:MediaStream | null = null
        //   const mediaRecorder: null | MediaRecorder = null
        //   watch(
        //     () => mediaRecorder.value,
        //     (recorder) => {
        //       if (recorder) {
        //         recorder.ondataavailable = (event) => {
        //           chunks.value.push(event.data)
        //         }
        //         recorder.onstop = () => {
        //           downloadVideFromBlob(chunks.value, 'poc.webm', 'video/webm')
        //         }
        //       }
        //     }
        //   )
        //   function onStop() {
        //     mediaRecorder.value?.stop()
        //     captureStream.value?.getTracks().forEach((track) => track.stop())
        //   }
        // mediaRecorder.value?.pause()
        // mediaRecorder.value?.resume()
      }}>
        <svg
          width="24px"
          style={{ marginBottom: 0 }}
          height="24px"
          className="remix"
          fill={"red"}
        >
          <use xlinkHref={`${remixiconUrl}#ri-record-circle-line`} />
        </svg>
        <span>Record</span>
      </button>}


      <div style={{ width: '400px', height: '400px', position: 'absolute', top: '-400px' }} id="vid-recorder"></div> */}

      <button
        className={style.button}
        onClick={async () => {
          window.location.href = "/end";
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 48 48"
          width="24px"
          style={{ marginTop: "1px" }}
          height="24px"
          // fill="red"
        >
          <g id="surface168711400">
            <path
              style={{
                stroke: "none",
                fillRule: "nonzero",
                fill: "#f26b4d",
                fillOpacity: 1,
              }}
              d="M 5.5 2.5 C 5.441406 2.5 5.394531 2.523438 5.339844 2.53125 C 5.257812 2.539062 5.1875 2.558594 5.109375 2.578125 C 4.976562 2.617188 4.855469 2.667969 4.738281 2.738281 C 4.695312 2.765625 4.640625 2.769531 4.597656 2.800781 C 4.570312 2.820312 4.558594 2.855469 4.53125 2.878906 C 4.421875 2.972656 4.339844 3.082031 4.261719 3.203125 C 4.222656 3.261719 4.175781 3.3125 4.144531 3.375 C 4.054688 3.566406 4 3.773438 4 4 L 4 40 C 4 40.6875 4.46875 41.289062 5.136719 41.457031 L 18.652344 44.835938 C 19.695312 45.097656 20.800781 44.859375 21.652344 44.199219 C 22.484375 43.546875 22.972656 42.554688 22.992188 41.5 L 31.5 41.5 C 32.429688 41.5 33.316406 41.128906 33.972656 40.472656 C 34.628906 39.816406 35 38.929688 35 38 L 35 28 C 35 27.171875 34.328125 26.5 33.5 26.5 C 32.671875 26.5 32 27.171875 32 28 L 32 38 C 32 38.132812 31.949219 38.261719 31.855469 38.355469 C 31.761719 38.449219 31.632812 38.5 31.5 38.5 L 23 38.5 L 23 10.078125 C 23 8.515625 21.964844 7.144531 20.460938 6.714844 C 19.308594 6.386719 18.066406 6.03125 16.207031 5.5 L 31.5 5.5 C 31.777344 5.5 32 5.722656 32 6 L 32 16 C 32 16.828125 32.671875 17.5 33.5 17.5 C 34.328125 17.5 35 16.828125 35 16 L 35 6 C 35 4.066406 33.433594 2.5 31.5 2.5 Z M 7 5.988281 L 19.636719 9.601562 C 19.851562 9.660156 20 9.855469 20 10.078125 L 20 41.4375 C 20 41.589844 19.929688 41.738281 19.808594 41.832031 C 19.6875 41.929688 19.527344 41.960938 19.378906 41.925781 L 7 38.828125 Z M 38.5 16.5 C 38.117188 16.5 37.734375 16.648438 37.441406 16.941406 C 36.855469 17.527344 36.855469 18.472656 37.441406 19.058594 L 38.882812 20.5 L 28.5 20.5 C 27.671875 20.5 27 21.171875 27 22 C 27 22.828125 27.671875 23.5 28.5 23.5 L 38.882812 23.5 L 37.441406 24.941406 C 36.855469 25.527344 36.855469 26.472656 37.441406 27.058594 C 38.027344 27.644531 38.972656 27.644531 39.558594 27.058594 L 43.558594 23.058594 C 44.144531 22.472656 44.144531 21.527344 43.558594 20.941406 L 39.558594 16.941406 C 39.265625 16.648438 38.882812 16.5 38.5 16.5 Z M 38.5 16.5 "
            />
          </g>
        </svg>
        <span style={{ color: "#f26b4d" }}>Exit</span>
      </button>
    </>
  );
};

export default observer(ReactionControl);
